import React, { useEffect, useState } from 'react';
import './blog.css';

const Blog = () => {
    const [blog, setBlog] = useState([]);
    const [error, setError] = useState();

    const getAllBlog = async() =>{
        try{
            const resp = await fetch("/data/db.json")
            if(!resp.ok){
                throw new Error('Failed to fetch data')
            }
            const data = await resp.json();
            setBlog(data.BlogData);
        }catch(err){
            setError(err.message);
        }
    }

    useEffect(()=>{
        getAllBlog();
    })

    const handleReadMore = (downloadUrl) => {
        window.open(downloadUrl, '_blank');
    };

    return (
        <>
            <div className="BlogsReact">
                <div className="Blogcards">
                    {blog.map((blog) => (
                        <div key={blog.id} className="BlogSubCard">
                            <div className="BlogImg">
                                <img src={blog.BlogImages} alt={blog.BlogTitle} />
                            </div>
                            <div className="BlogDetails">
                                <h3>{blog.BlogTitle}</h3>
                                <button className='BlogBtn' onClick={() => handleReadMore(blog.BlogDownload)}>
                                    Read More
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Blog;
